















import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import { DateTime } from 'luxon';

@Component({
    model: {
        prop: 'dateTime',
        event: 'change'
    }
})
export default class DateTimePicker extends Vue {
    @Prop({ type: String, required: false })
    private dateTime!: string;
    @Prop({ type: String, required: false, default: '' })
    private error!: string;
    @Prop({ type: String, required: false, default: 'Date' })
    private dateLabel!: string;
    @Prop({ type: String, required: false, default: 'Time' })
    private timeLabel!: string;
    @Prop({ type: Boolean, required: false, default: false })
    private disabled!: boolean;

    private date = '';
    private time = '';

    @Watch('date')
    @Watch('time')
    dateChanged() {
        let local = DateTime.local();
        if (this.date) {
            local = DateTime.fromISO(this.date);
        }
        let hour = 0, minutes = 0;
        if (this.time && this.time !== '12:00 AM') {
            const regex = /(\d+):(\d+)/gm;
            let match = regex.exec(this.time);
            if (match) {
                hour = Number(match[1]);
                minutes = Number(match[2]);
            }
        }
        const newValue = DateTime.fromObject({ year: local.year, month: local.month, day: local.day, hour: hour, minute: minutes, zone: 'America/Chicago' }).toISO();
        this.$emit('change', newValue);
    }

    @Watch('dateTime')
    dateTimeChanged(newVal: any, oldVal?: string) {
        if (this.dateTime && (!oldVal || oldVal.endsWith('Z'))) {
            const datetime = DateTime.fromISO(this.dateTime, { zone: 'America/Chicago' });
            const newDate = datetime.setZone('local', { keepLocalTime: true }).toISO();
            if (newDate !== this.date) {
                this.date = newDate;
            }
            const newTime = datetime.toFormat('HH:mm');
            if (newTime !== this.time) {
                this.time = newTime;
            }
        }
    }

    public created() {
        this.dateTimeChanged(this.dateTime);
    }
}
